import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IEditNameValueListStyles {
  root?: IStyle;
  list?: IStyle;
}

export interface IEditNameValueListClassNames {
  root: string;
  list: string;
}

export const editNameValueListStylesDefault = (_theme: IH2OTheme): Partial<IEditNameValueListStyles> => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '150px',
  },
  list: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
});
